var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPedidos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pedidos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66663 10.6172H12.5M6.66663 13.9505H10.3166M8.33329 5.45052H11.6666C13.3333 5.45052 13.3333 4.61719 13.3333 3.78385C13.3333 2.11719 12.5 2.11719 11.6666 2.11719H8.33329C7.49996 2.11719 6.66663 2.11719 6.66663 3.78385C6.66663 5.45052 7.49996 5.45052 8.33329 5.45052Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 3.79883C16.1083 3.94883 17.5 4.97383 17.5 8.78216V13.7822C17.5 17.1155 16.6667 18.7822 12.5 18.7822H7.5C3.33333 18.7822 2.5 17.1155 2.5 13.7822V8.78216C2.5 4.98216 3.89167 3.94883 6.66667 3.79883",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidos);
export default __webpack_public_path__ + "static/media/Pedidos.aa082c8d8ffaafb77807eba0038c9532.svg";
export { ForwardRef as ReactComponent };